export const DEFAULT_PERCENTAGE_INFO = {
  percentageChange: 0,
  percentageChangeColor: "",
  percentageChangeSign: "",
  percentageChangeIcon: "",
  percentageChangeBGColor: "",
};
